<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <SecondaryButton
          @click="viewData"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-eye"
          iconClass=""
        >
        </SecondaryButton>
      </template>
      <span class="text-capitalize">View Payload</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          class="ma-0 mr-1 primary---text"
          v-bind="attrs"
          v-on="on"
          @click="viewLogs()"
        >
          mdi-format-list-bulleted
        </v-icon>
      </template>
      <span class="text-capitalize">View Logs</span>
    </v-tooltip>
    <v-tooltip
      top
      v-if="this.params && this.params.data && !this.params.data.is_success"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          class="ma-0 mr-1 primary---text"
          v-bind="attrs"
          v-on="on"
          @click="addForm()"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span class="text-capitalize">Edit item</span>
    </v-tooltip>
    <!-- <v-tooltip
      top
      v-if="this.params && this.params.data && !this.params.data.is_success"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          class="ma-0 mr-1 primary---text"
          v-bind="attrs"
          v-on="on"
          @click="editForm()"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span class="text-capitalize">Update Items</span>
    </v-tooltip> -->
  </div>
</template>

<script>
export default {
  name: "ItemIntegrationButton",
  data() {
    return {
      userPermissions: null,
    };
  },
  methods: {
    addForm() {
      this.params.context.parentComponent.addIntegrationItem(
        this.params.data.id
      );
    },
    editForm() {
      this.params.context.parentComponent.editItemMaster(
        this.params.data.id,
        this.params.request_type
      );
    },
    viewData() {
      this.params.context.parentComponent.viewPayload(this.params.data.id);
    },
    viewLogs() {
      this.params.context.parentComponent.viewIntegrationItemLogs(
        this.params.data.id
      );
    },
  },
};
</script>
